import React from 'react'
import {useCentralServices} from './useCentralServices'
import {SiteModel} from '../../../central/model'
import {selectMapperByKeys} from '../../mappers/util'

export const useCampaments = () => {
  const [loading, setLoading] = React.useState(false)
  const [campaments, setCampaments] = React.useState<{value: string; label: string}[]>([])
  const {getCamps} = useCentralServices()

  const getCampamentsFn = async (
    filters: SiteModel,
    page: number,
    options: {all: boolean; value: any; label: string} = {all: false, value: null, label: 'TODOS'},
  ) => {
    try {
      setLoading(true)
      const campaments = await getCamps(filters, page)
      const mappedCampaments = selectMapperByKeys(campaments, 'id', 'nombre')
      let filteredData = mappedCampaments.filter((item) => item.value !== '4EsB2NAAsDA=')
      if (options.all && filteredData.length > 0) {
        filteredData = [{value: options.value, label: options.label}, ...filteredData]
        setCampaments(filteredData)
        return filteredData
      } else {
        setCampaments(filteredData)
        return filteredData
      }
    } catch (error) {
      console.error('Error fetching campaments:', error)
    } finally {
      setLoading(false)
    }
  }

  const clearCampaments = () => {
    setCampaments([])
  }

  return {
    loading,
    campaments,
    getCampaments: getCampamentsFn,
    clearCampaments,
  }
}
